import axios from "@/store/axios"
export default {
  state: {
    point: null, //chosen point
    myPoint: null, //chosen point
    points: [],
    filtered: [],
    pointsInRadius: [],
    currentRadius: 5,
    circleOnMapInstance: null,
  },
  getters: {
    points: (state) => state.points,
    point: (state) => state.point,
    myPoint: (state) => state.myPoint,
    pointById: (state) => (id) => state.points.find((p) => p._id === id),
    pointFiltered: (state) => state.filtered,
    currentRadius: (state) => state.currentRadius,
    pointsInRadius: (state) => state.pointsInRadius,
    circleOnMapInstance: (state) => state.circleOnMapInstance,
  },
  mutations: {
    //sets all points
    "points/set": (state, payload) => {
      state.points = payload
      state.filtered = [...state.points]
    },
    //sets chosen points
    "points/chosen": (state, ids) => {
      state.filtered =
        !ids?.length < 0
          ? []
          : state.points.filter((e) => ids.indexOf(e._id) !== -1)
    },
    //sets one point
    "point/set": (state, payload) => (state.point = payload),
    //sets one point
    "myPoint/set": (state, payload) => (state.myPoint = payload),
    //sets one point
    "point/findByIdAndSet": (state, id) => {
      const point = id ? state.points.find((e) => e._id === id) : null
      state.point = point ? point : null
    },
    //filters the point's array by point's key and point's val
    "points/filter": (state, { key, val }) => {
      state.filtered = !val
        ? [...state.points]
        : state.points.filter((f) => f[key] === val)
    },
    //store one point
    "point/store": (state, payload) => state.points.push(payload),
    //destroys one point
    "point/destroy": (state, id) =>
    (state.points = state.points.filter((item) => {
      return item._id !== id
    })),
    //updates one point
    "point/update": (state, payload) => {
      state.points = state.points.map((item) => {
        if (item._id === payload._id) {
          return { ...item, ...payload }
        }
        return item
      })
    }, //sets current radius
    "point/currentRadiusSet": (state, payload) => {
      state.currentRadius = payload.currentRadius
    }, //set point in specific radius
    "point/setPointsInRadius": (state, payload) => {
      state.pointsInRadius = payload
    },

    "point/setCircleOnMapInstance": (state, payload) => {
      state.circleOnMapInstance = payload.circleOnMapInstance
    },
  },
  actions: {
    //fetch all points
    "point/index": async (context) => {
      const { data } = await axios.get("/point")
      context.commit("points/set", data)
    },
    //fetch one point by id
    "point/show": async (context, id) => {
      let { data } = await axios.get("/point/" + id)
      context.commit("point/set", data)
    },
    //stores one point
    "point/store": async (context, payload) => {
      let { data } = await axios.post("/point", { ...payload })
      context.commit("point/store", data)
    },
    //destroys one point
    "point/destroy": async (context, id) => {
      await axios.delete("/point/" + id)
      context.commit("point/destroy", id)
    },
    //updates one point by its id
    "point/update": async (context, payload) => {
      await axios.put("/point/" + payload._id, payload)
      context.commit("point/update", payload)
    },
    "point/indexPointsInRadius": async (context, payload) => {
      const { radius, lat, lng } = payload
      const { data } = await axios.get(`/point/${lng}/${lat}/${radius * 1000}`)
      context.commit("point/setPointsInRadius", data)
    },
  },
}
